import { IconButton } from '@genial/components';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../components/TableContent';
import {
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { customersTableHead } from '../../constants';
import { CustomerNameLoading } from '../CustomerTableItem/shared/CustomerName';
import { IncomeTaxButtonLoading } from '../CustomerTableItem/shared/IncomeTaxButton';

export const CustomerListLoadingItemDesktop: React.FC = () => {
  const getFlex = (index: number) => {
    const currentHead = customersTableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs" h="80px">
      <TableContentItemColumn flex={getFlex(0)}>
        <CustomerNameLoading />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <IncomeTaxButtonLoading />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <DoubleTextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <IconButton
          testId="loading-customer-detail-button"
          icon="ChevronRight"
          iconSize="xxs"
          iconColor="neutral.light"
        />
      </TableContentItemColumn>
    </TableContent>
  );
};
